// eslint-disable-next-line no-restricted-imports
import { SafeInnerHtmlSetter } from 'components/shared/util/SafeInnerHtmlSetter';

import styles from './index.module.scss';

type HighlightProps = {
  highlightedValue: string;
};

/** Represents a component that is used to visualize a highlighted word. */
export const Highlight = ({
  highlightedValue,
}: HighlightProps): JSX.Element => {
  return (
    <SafeInnerHtmlSetter
      element="span"
      content={highlightedValue}
      profile="highlight"
      className={styles.highlighter}
    />
  );
};
